export default __webpack_public_path__ + "static/media/verified.d01a84cc.svg";